import { render, staticRenderFns } from "./tigerSwap.vue?vue&type=template&id=5e0d7536"
import script from "./tigerSwap.vue?vue&type=script&lang=js"
export * from "./tigerSwap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports